import { render, staticRenderFns } from "./GroupsPushTag.vue?vue&type=template&id=500e86e1&"
import script from "./GroupsPushTag.vue?vue&type=script&lang=ts&"
export * from "./GroupsPushTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports